/** 四川目的地详情页 hero 横幅 */
export const SICHUAN_HERO_IMG = require("@/assets/destiantion/sichuan/scindex.jpg");

/** 川渝目的地详情页 hero 横幅 */
export const SCANDCQ_HERO_IMG = require("@/assets/destiantion/scandcq/scandcqindex.jpg");

/** 北京目的地详情页 hero 横幅 */
export const BEIJING_HERO_IMG = require("@/assets/destiantion/beijing/beijingindex.jpg");

/** 西安目的地详情页 hero 横幅 */
export const XIAN_HERO_IMG = require("@/assets/destiantion/xian/xianindex.jpg");

export const DEST_IMGS = [
  require("@/assets/destiantion/sichuan.jpg"),
  require("@/assets/destiantion/scandcq.jpg"),
  require("@/assets/destiantion/beijing.jpg"),
  require("@/assets/destiantion/xian.jpg"),
];

/** 四川 6 日行程每日配图 */
export const SICHUAN_DAY_IMGS = [
  [
    require("@/assets/destiantion/sichuan/oneday1-1.jpg"),
    require("@/assets/destiantion/sichuan/oneday1-2.jpg"),
    require("@/assets/destiantion/sichuan/oneday1-3.jpg"),
  ],
  [
    require("@/assets/destiantion/sichuan/secondday1-1.jpg"),
    require("@/assets/destiantion/sichuan/secondday1-2.jpg"),
  ],
  [
    require("@/assets/destiantion/sichuan/threeday1-1.jpg"),
    require("@/assets/destiantion/sichuan/threeday1-2.jpg"),
  ],
  [
    require("@/assets/destiantion/sichuan/fourday1-1.jpg"),
    require("@/assets/destiantion/sichuan/fourday1-2.jpg"),
    require("@/assets/destiantion/sichuan/fourday1-3.jpg"),
  ],
  [
    require("@/assets/destiantion/sichuan/fiveday1-1.jpg"),
    require("@/assets/destiantion/sichuan/fiveday1-2.jpg"),
    require("@/assets/destiantion/sichuan/fiveday1-3.jpg"),
  ],
  [
    require("@/assets/destiantion/sichuan/sixday1-1.jpg"),
    require("@/assets/destiantion/sichuan/sixday1-2.jpg"),
  ],
];

/** 川渝 9 日行程每日配图 */
export const SCANDCQ_DAY_IMGS = [
  [
    require("@/assets/destiantion/scandcq/oneday1-1.jpg"),
    require("@/assets/destiantion/scandcq/oneday1-2.jpg"),
    require("@/assets/destiantion/scandcq/oneday1-3.jpg"),
  ],
  [
    require("@/assets/destiantion/scandcq/secondday1-1.jpg"),
    require("@/assets/destiantion/scandcq/secondday1-2.jpg"),
  ],
  [
    require("@/assets/destiantion/scandcq/threeday1-1.jpg"),
    require("@/assets/destiantion/scandcq/threeday1-2.jpg"),
    require("@/assets/destiantion/scandcq/threeday1-3.jpg"),
  ],
  [
    require("@/assets/destiantion/scandcq/fourday1-1.jpg"),
    require("@/assets/destiantion/scandcq/fourday1-2.jpg"),
  ],
  [
    require("@/assets/destiantion/scandcq/fiveday1-1.jpg"),
    require("@/assets/destiantion/scandcq/fiveday1-2.jpg"),
  ],
  [
    require("@/assets/destiantion/scandcq/sixday1-1.jpg"),
    require("@/assets/destiantion/scandcq/sixday1-2.jpg"),
  ],
  [
    require("@/assets/destiantion/scandcq/sevenday1-1.jpg"),
    require("@/assets/destiantion/scandcq/sevenday1-2.jpg"),
    require("@/assets/destiantion/scandcq/sevenday1-3.jpg"),
  ],
  [
    require("@/assets/destiantion/scandcq/eightday1-1.jpg"),
    require("@/assets/destiantion/scandcq/eightday1-2.jpg"),
    require("@/assets/destiantion/scandcq/eightday1-3.jpg"),
  ],
];

/** 北京 7 日行程每日配图 */
export const BEIJING_DAY_IMGS = [
  [
    require("@/assets/destiantion/beijing/DAY1-1.jpg"),
    require("@/assets/destiantion/beijing/DAY1-2.jpg"),
    require("@/assets/destiantion/beijing/DAY1-3.jpg"),
  ],
  [
    require("@/assets/destiantion/beijing/DAY2-1.jpg"),
    require("@/assets/destiantion/beijing/DAY2-2.jpg"),
    require("@/assets/destiantion/beijing/DAY2-3.jpg"),
  ],
  [
    require("@/assets/destiantion/beijing/DAY3-1.jpg"),
    require("@/assets/destiantion/beijing/DAY3-2.jpg"),
    require("@/assets/destiantion/beijing/DAY3-3.jpg"),
  ],
  [
    require("@/assets/destiantion/beijing/DAY4-1.jpg"),
    require("@/assets/destiantion/beijing/DAY4-2.jpg"),
    require("@/assets/destiantion/beijing/DAY4-3.jpg"),
  ],
  [
    require("@/assets/destiantion/beijing/DAY5-1.jpg"),
    require("@/assets/destiantion/beijing/DAY5-2.jpg"),
    require("@/assets/destiantion/beijing/DAY5-3.jpg"),
  ],
  [
    require("@/assets/destiantion/beijing/DAY6-1.jpg"),
    require("@/assets/destiantion/beijing/DAY6-2.jpg"),
  ],
];

/** 西安 6 日行程每日配图 */
export const XIAN_DAY_IMGS = [
  [
    require("@/assets/destiantion/xian/DAY1-1.jpg"),
    require("@/assets/destiantion/xian/DAY1-2.jpg"),
    require("@/assets/destiantion/xian/DAY1-3.jpg"),
  ],
  [
    require("@/assets/destiantion/xian/DAY2-1.jpg"),
    require("@/assets/destiantion/xian/DAY2-2.jpg"),
    require("@/assets/destiantion/xian/DAY2-3.jpg"),
  ],
  [
    require("@/assets/destiantion/xian/DAY3-1.jpg"),
    require("@/assets/destiantion/xian/DAY3-2.jpg"),
  ],
  [
    require("@/assets/destiantion/xian/DAY4-1.jpg"),
    require("@/assets/destiantion/xian/DAY4-2.jpg"),
  ],
  [
    require("@/assets/destiantion/xian/DAY5-1.jpg"),
    require("@/assets/destiantion/xian/DAY5-2.jpg"),
    require("@/assets/destiantion/xian/DAY5-3.jpg"),
  ],
];

export { DEST_DETAIL_GALLERY } from "./ourPhotos";

